import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-staff-user-type-map',
  templateUrl: './staff-user-type-map.component.html',
  styleUrls: ['./staff-user-type-map.component.css']
})
export class StaffUserTypeMapComponent implements OnInit {

  Submitted = false;
  StaffList = [];
  Count1 = 0;
  PersonList = [];
  UserTypeList = [];
  EmployeeCategoryList = [];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  StaffUserTypeModel = {
    CurrentIndex: 0,
    PageSize: 0,
    EmployeeCategoryID: 0,
    UserTypeID: 0,

  }

  ValidityState() {
    return this.StaffUserTypeModel.UserTypeID == 0;
  }

  GetStaffForUserTypeMap() {
    this.Submitted = true;
    this.spinnerService.show();
    this.adminservice.GetStaffForUserTypeMap(JSON.stringify(this.StaffUserTypeModel)).subscribe((data: any) => {
      this.StaffList = data.StaffList;

      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });

  };



  SelectModel = {
    IsSelect: false,
  }

  SelectAll() {
    if (this.SelectModel.IsSelect) {
      for (var i = 0; i < this.StaffList.length; i++) {
        this.StaffList[i].Active = true;
      }
    }
    if (this.SelectModel.IsSelect == false) {
      for (var i = 0; i < this.StaffList.length; i++) {
        this.StaffList[i].Active = false;
      }
    }
  }

  ChangeSelect(item) {
    this.Count1 = 0;
        for (var i = 0; i < this.StaffList.length; i++) {
      if (this.StaffList[i].Active) {
        this.Count1 = this.Count1 + 1

      }
    }

    if (this.Count1 == this.StaffList.length) {
      this.SelectModel.IsSelect = true;

    }
    else {
      this.SelectModel.IsSelect = false;
    }

  }


  SaveStaffUserTypeMap() {
    this.PersonList = [];
    this.Submitted = true;
    for (var i = 0; i < this.StaffList.length; i++) {

      var item = {
        StaffID: this.StaffList[i].StaffID,
        UserTypeID: this.StaffList[i].UserTypeID
      }
      this.PersonList.push(item);

    }
    this.spinnerService.show();
    this.adminservice.SaveStaffUserTypeMap(JSON.stringify(this.PersonList), JSON.stringify(this.StaffUserTypeModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
      if (data.webdata.Status) {
        this.ClearSelection();
        this.GetStaffForUserTypeMap();
      }
     
    });

  }


  ngOnInit() {
    this.BindUserType();
    this.GetEmployeeCategory();
  }

  BindUserType() {
    this.lookupservice.GetLookupsList('StaffUserType', '').subscribe((data: any) => {
      this.UserTypeList = data.LookupItems;
    });
  };

  GetEmployeeCategory() {
    this.lookupservice.GetLookupsList('EmployeeCategory', '').subscribe((data: any) => {
      this.EmployeeCategoryList = data.LookupItems;
    });
  };


  ClearSelection() {
    this.SelectModel.IsSelect = false;
  }

}
